import React, { useCallback, useRef } from "react";
import { IconButton, Loader } from "@DR/components/common";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { Link } from "gatsby";

const Blog = () => {
  const [mediaData, setMediaData] = React.useState([]);
  const [blogs, setBlogs] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const sliderRef = useRef(null);

  const decodeHTML = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const init = async () => {
    setLoading(true);
    const response = await fetch(
      `${process.env.DR_BLOG_API_URL}/posts?per_page=30`
    );
    const data = await response.json();
    setBlogs(data);
    for (let i = 0; i < data.length; i++) {
      fetch(`${process.env.DR_BLOG_API_URL}/media/${data[i].featured_media}`)
        .then((res) => res.json())
        .then((result) => {
          setMediaData((prevData) => [...prevData, result]);
          setLoading(false);
        })
        .catch((error) => {
          console.log("Error===>", error);
          setLoading(false);
        });
    }
  };

  React.useEffect(() => {
    init();
  }, []);

  return (
    <section className="bg-white py-16" id="blog">
      <div className="max-sm:container">
        <div className="text-center mb-[35px]">
          <h2 className="text-[40px] text-custom-primary font-bold">
            Debt Redemption Blogs
          </h2>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="relative h-full overflow-x-hidden">
              <div className="absolute z-10 -left-2 translate-y-[-50%] top-1/2 hidden sm:block">
                <IconButton onPress={handlePrev} arrow="left" isRounded />
              </div>
              <Swiper
                pagination={{
                  clickable: true,
                  el: ".blog-swiper-pagination",
                  renderBullet: function (index, className) {
                    return (
                      '<span class="!h-2.5 !w-2.5 rounded-full m-2 top-0 right-0 mr-2 bg-custom-gray ' +
                      className +
                      '"></span>'
                    );
                  },
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                speed={500}
                modules={[Pagination, Autoplay]}
                ref={sliderRef}
                slidesPerView={1}
                breakpoints={{
                  640: {
                    slidesPerView: 1.3,
                  },
                  768: {
                    slidesPerView: 1.6,
                  },
                  960: {
                    slidesPerView: 2,
                  },
                  1364: {
                    slidesPerView: 2.8,
                  },
                }}
                spaceBetween={30}
                centeredSlides
                loop
              >
                {blogs.slice(0, 6).map((blog, index) => (
                  <SwiperSlide key={index} className="pb-4">
                    {({ isActive }) => (
                      <Link to={`/blogs/${blog?.slug}/`}>
                        <div
                          className={`shadow bg-white rounded-[20px] transition-all duration-500 ${
                            isActive ? "opacity-100" : "opacity-50"
                          }`}
                        >
                          <img
                            src={
                              mediaData.find(
                                (media) => media.id === blog?.featured_media
                              )?.source_url ??
                              "https://adc-dr-assets.s3.amazonaws.com/debtredemption/images/blog-blank-image.webp"
                            }
                            className="rounded-t-3xl w-full min-h-[250px] sm:min-h-[348.75px] max-h-[250px] sm:max-h-[348.75px] object-cover"
                            alt=""
                          />
                          <div className="py-[24px] px-[16px]">
                            <h2 className="text-[28px] truncate text-custom-primary font-semibold mb-3.5">
                              {decodeHTML(blog?.title?.rendered)}
                            </h2>
                            <span className="border-b-2 text-base text-custom-primary font-light">
                              Read More
                            </span>
                          </div>
                        </div>
                      </Link>
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="absolute z-10 -right-2 translate-y-[-50%] top-1/2 hidden sm:block">
                <IconButton onPress={handleNext} arrow="right" isRounded />
              </div>
            </div>
            <div className="blog-swiper-pagination mt-[30px] flex justify-center" />
          </>
        )}
      </div>
    </section>
  );
};

export default Blog;
